import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { slate } from '@vimeo/iris/color';
import { CircleInfo } from '@vimeo/iris/icons';

export const FileTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => (theme.name === 'dark' ? slate(100) : slate(800))};
  font-size: ${rem(14)};
  display: inline-block;
  width: 30%;
`;

export const DownloadButtonColumn = styled.div`
  display: inline-block;
  width: 70%;
  text-align: right;
  padding: ${rem(10)} 0;
`;

export const FileDetails = styled.span`
  color: #8a9599;
  font-size: ${rem(14)};
  margin-right: ${rem(10)};
`;

export const FileConfigRow = styled.div`
  border-bottom: ${rem(1)} solid #e3e8e9;
  height: ${rem(60)};
  &:last-child {
    border: 0;
  }
`;

export const DownloadPanelStyled = styled.div`
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  @media (min-height: 480px) {
    overflow: hidden;
  }
`;

const panelNotificationStyles = css`
  padding: ${rem(20)};
  background-color: #f2f4f5;
  border-radius: ${rem(5)};
  display: block;
  position: relative;
  font-size: ${rem(14)};
  line-height: 1.3;
  color: #1a2e3b;
  text-align: left;
`;

export const PanelNotification = styled.div`
  ${panelNotificationStyles};
`;

export const PanelNotificationLink = styled.a`
  ${panelNotificationStyles};
`;

export const MenuContainer = styled.div`
  display: none;

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-width: ${rem(7)} ${rem(9)} ${rem(7)} 0;
    border-style: solid;
    border-color: transparent #ffffff transparent transparent;
    bottom: ${rem(33)};
    left: 50%;
    transform: translateX(-50%) rotate(270deg);
  }
  &::before {
    border-top: ${rem(7)} solid transparent;
    border-right: ${rem(9)} solid #d0d8db;
    border-bottom: ${rem(7)} solid transparent;
  }
  &::after {
    bottom: ${rem(34)};
  }
`;

export const MenuPanel = styled.ul`
  position: absolute;
  left: 50%;
  transform: translate(-50%, ${rem(10)});
  padding: ${rem(5)} 0;
  font-size: ${rem(13)};
  font-weight: 400;
  border-radius: ${rem(3)};
  box-shadow: ${rem(3)} 0 ${rem(5)} 0 rgba(0, 0, 0, 0.1);
  border: ${rem(1)} solid #d0d8db;
  background-color: #ffffff;
  bottom: ${rem(54)};
  max-height: calc(100% - ${rem(40)});
  overflow-y: auto;
  &:hover {
    display: block;
  }
`;

export const MenuOption = styled.li`
  width: 100%;
  min-width: ${rem(121)};
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis;
  font-size: ${rem(13)};
  font-weight: 400;
  padding: 0 ${rem(5)};
`;

export const MenuWrapper = styled.div`
  position: static;
  display: inline-block;

  &::before {
    content: '';
    width: 100%;
    display: block;
    height: ${rem(19)};
    bottom: 100%;
  }

  &:hover {
    .menu-container {
      display: block;
    }
  }
`;

export const ColdStorageInfoIcon = styled(CircleInfo)`
  width: ${rem(17)};
  vertical-align: bottom;
`;

export const FetchBtnWidth = styled.button`
  width: ${rem(90)};
  display: inline-flex;
  font-weight: 700;
  cursor: pointer;
  border: ${rem(1)} solid;
  border-radius: ${rem(3)};
  transition: all 0.1s ease-in-out;
  justify-content: center;
`;
